import React, { useState, useEffect } from "react";
import grey from "@material-ui/core/colors/grey";
import {
  withStyles,
  makeStyles,
  createStyles,
  useTheme,
} from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import {
  FormHelperText,
  Input,
  InputLabel,
  InputBase,
} from "@material-ui/core";
import { reportFilterTot } from "./ReportObj"
import { ToastError } from "../../services/ToastMsg";
import { getRequest } from "../../services/ApiServices";
import { getCookie } from "../../services/Cookies";
import FilterComponents from "../FilterComponents/FilterComponents";
import { FilterComponentObj } from "../FilterComponents/FilterComponentObj";

export default function FiltersReportTot(props) {
  const { filterReportTot, clearFilter,FormatClearFilter } = props;
  const [formObj, setFormObj] = useState(reportFilterTot);
  const [TransformerNamesMultipleSelect, setTransformerNamesMultipleSelect] = useState([]);
  const [transformDataList, setTransformDataList] = React.useState([]);
  const [filtercomObj, setfiltercomObj] = React.useState(FilterComponentObj);
const [GlobalFilterSettingValue, setGlobalFilterSettingValue] = React.useState(localStorage.getItem('GlobalFilterSetting'));

  const applyFilter = (Obj) => {
    
    filterReportTot(Obj);
    FormatClearFilter(Obj)
    console.log(formObj);
  };

  const onClearFilter = (Obj) => {
    filterReportTot(Obj);
    setFormObj(reportFilterTot);
    setTransformerNamesMultipleSelect([]);
    let dateFormat = "";
    FormatClearFilter(Obj)
    clearFilter();
  }

  const fetchTransformerDataListForDropdown = async () => {
    //
    const customerKey = getCookie("clientId");
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Transformer/${customerKey}`;
    await getRequest(url)
      .then((res) => {
        //  console.log("Responce", res);
        if (res.status == 200) {
          setTransformDataList(res.data);
          console.log("Responce", transformDataList);
        } else {
          ToastError(res.data.message);
        }
      })
      .catch((error) => { });
  }
 
    const defaultValue = (val) => {
      if (val !== "" && val !== undefined && val !== "null") {
          let Obj = JSON.parse(val);
          setfiltercomObj(Obj);
          console.log('getcookievalue', formObj)
      }
  }
  useEffect(() => {
    fetchTransformerDataListForDropdown();
    defaultValue(GlobalFilterSettingValue);
  }, []);

  return (
    <div>
     <Box className="decarbox1" component="div" style={{padding: "20px"}}  >
      <FilterComponents screen={"reportsToT"} defaultDate={props.defaultDate} filtervalue={["CustomerName","SerialNumber","Location","Manufacturer","Voltage","TotSample_number","Lab_Tot","Rating","TotReportDateComponent","TotSubCustomer_NameComponent","TotUnitDescripitionComponent"]} applyFilter={applyFilter} reset={onClearFilter} />
    </Box>
    </div>
  );
}

